import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import HeroCore from "@/components/nearcore/HeroCore";
import ModelCompare from "@/components/nearcore/ModelCompare";
import Marquee from "@/components/nearcore/Marquee";
import History from "@/components/nearcore/History";
import Roles from "@/components/nearcore/Roles";
import ProcessCore from "@/components/nearcore/ProcessCore";
import NoSurprises from "@/components/nearcore/NoSurprises";
import { Reveal } from "@/components/nearcore/Reveal";

type HomePageProps = { onQuote: () => void };

export default function HomePage({ onQuote }: HomePageProps) {
  return (
    <>
      <Seo
        title="nearcore — Senior Data & Cloud Nearshore Staff Augmentation"
        description="nearcore is a boutique nearshore staff augmentation agency placing senior Data & Cloud engineers from Latin America with US companies, working in your time zone."
        path="/"
      />
      <HeroCore onQuote={onQuote} />
      <Marquee />
      <main>
        <ModelCompare />
        <Roles />
        <ProcessCore />
        <NoSurprises onQuote={onQuote} />
        <History />
        <section className="mx-auto max-w-3xl px-5 pb-20 sm:px-8" data-testid="home-faq">
          <Reveal>
            <div className="rounded-2xl bg-brand-mist p-8 text-center sm:p-10">
              <h2 className="font-display text-2xl font-extrabold text-brand-teal sm:text-3xl">
                Questions, answered
              </h2>
              <p className="mx-auto mt-3 max-w-md text-base text-brand-slate">
                Pricing, vetting, time zones, replacement guarantee: everything companies and senior engineers ask us, in one place.
              </p>
              <Link
                to="/faq"
                data-testid="home-faq-more-link"
                className="mt-6 inline-block rounded-full bg-brand-orange px-8 py-3 text-sm font-bold text-white transition-colors duration-300 hover:bg-brand-orange-dark"
              >
                Read the full FAQ
              </Link>
            </div>
          </Reveal>
        </section>
      </main>
    </>
  );
}
